import { IPIValidator } from '@App/helpers/validate'
import { Maybe } from '@Types'

export const isPublisherNameAndIpiValid = (publisherName: string, ipiNumber: Maybe<string>) =>
    !(publisherName.length > 200 || !IPIValidator(ipiNumber, true) || !publisherName || !ipiNumber)
